export class PanelListConstants {

    public static readonly StandardFilterLength: number = 5;

    //Constants for empty results
    public static readonly NoResultStatus: string = 'info';
    public static readonly NoResultMessage: string = 'No result found';
    public static readonly NoResultDisplayButtons: boolean = false;
    public static readonly NoResultSubTitle: string = '';

    //Change request items constants
    public static readonly ChangeRequestItemType_FilterName: string ='changeRequestItemType';
    public static readonly ChangeRequestItemType_Manual: string ='Manual';
    public static readonly ChangeRequestItemType_PeriodicReview: string ='Periodic Review';

    //Phases numbers for effective date and Request Effective
    public static readonly RequestedEffectiveDatePhases: number[] = [1, 2, 3, 4, 10];
    public static readonly EffectiveDatePhases: number[] = [5, 6, 7, 9];

    public static readonly DefaultView: string = 'Default View';
    public static readonly AssignmentView : string = 'Assignment View'
    public static readonly WhereAmIUsedView : string = 'Where Am I Used View'

    public static readonly SelectedMenuItemStyleClass : string = 'font-bold bg-black-alpha-10'
    public static readonly SelectedMenuItemIcon : string = 'fa fa-check';
    public static readonly EmptyString : string = ''
}
